<template>
    <svg width="27" height="29" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12.8826 4.97968C13.2365 5.30912 13.2564 5.86309 12.9269 6.21702L7.55856 11.9846C7.22913 12.3386 6.67515 12.3584 6.32122 12.029L3.117 9.04655C2.76307 8.71712 2.74321 8.16314 3.07264 7.80921C3.40207 7.45529 3.95604 7.43542 4.30997 7.76486L6.87335 10.1508L11.6453 5.02404C11.9747 4.67011 12.5287 4.65025 12.8826 4.97968Z"
              fill="white" />
    </svg>
</template>
<script>
export default {
    name: "CheckWhite",
};
</script>
<style lang="scss" scoped></style>